import _ from 'lodash';
import {
  FETCH_USER_HANDLER_SELECTIONS_SUCCESS,
  SAVE_USER_HANDLER_SELECTION_REQUEST,
  DELETE_USER_HANDLER_SELECTION_REQUEST,
} from '../../../../user/redux/actions/types/UserActionTypes';
import { ENTERED_WIZARD } from '../../../common/redux/actions/types/SelectionCriteriaWizardActionTypes';
import handlersMapper from '../mappers/handlersMapper';
import {
  HANDLER_CHECKED,
  DESELECT_ALL_HANDLERS,
  RETRIEVE_OUTBOUND_HANDLER_REQUEST,
  RETRIEVE_OUTBOUND_HANDLER_SUCCESS,
  RETRIEVE_OUTBOUND_HANDLER_FAILURE,
  SELECT_ALL_HANDLERS,
} from '../actions/types/HandlerActionTypes';
import { LOGGED_OUT } from '../../../../../core/modules/security/redux/actions/types/SecurityActionTypes';
import filterHandlersIfExistsInPostalOperator from '../filters/filterHandlersIfExistsInPostalOperator';

export const initialState = {
  nodes: [],
  handlers: [],
  selections: [],
  checkedHandlers: [],
  isLoading: false,
};

const handleUserHandlerSelectionRequest = (action, state) => {
  const selections = [...state.selections];

  const indexOfExistingSelection = _.findIndex(selections, { name: action.payload.selectionName });
  const newSelection = {
    name: action.payload.selectionName,
    handlers: action.payload.selectedHandlers,
  };

  if (indexOfExistingSelection === -1) {
    selections.push(newSelection);
  } else {
    selections[indexOfExistingSelection] = newSelection;
  }

  selections.sort((a, b) => a.name.localeCompare(b.name));
  return {
    ...state,
    selections,
  };
};

const handleUserHandlerSelectionDeleteRequest = (action, state) => {
  let selections = [...state.selections];
  selections = selections.filter(item => item.name !== action.payload);
  selections.sort((a, b) => a.name.localeCompare(b.name));
  return {
    ...state,
    selections,
  };
};

export const handlerReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_USER_HANDLER_SELECTIONS_SUCCESS:
      return {
        ...state,
        selections: [...action.payload.selections]
          .map(selection => ({
            ...selection,
            name: selection.name === 'LAST_SELECTION' ? 'Your last selection' : selection.name,
          }))
          .sort((a, b) => a.name.localeCompare(b.name)),
      };
    case RETRIEVE_OUTBOUND_HANDLER_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case RETRIEVE_OUTBOUND_HANDLER_SUCCESS:
      return {
        ...state,
        nodes: handlersMapper(action.payload),
        isLoading: false,
      };
    case RETRIEVE_OUTBOUND_HANDLER_FAILURE:
      return {
        ...state,
        isLoading: false,
      };
    case HANDLER_CHECKED:
      return {
        ...state,
        checkedHandlers: filterHandlersIfExistsInPostalOperator(
          action.checkedHandlers,
          state.nodes,
        ),
      };
    case SELECT_ALL_HANDLERS:
      return {
        ...state,
        checkedHandlers: action.payload.nodes.map(node => node.value),
      };
    case DESELECT_ALL_HANDLERS:
      return {
        ...state,
        checkedHandlers: [],
      };
    case ENTERED_WIZARD:
      return initialState;
    case SAVE_USER_HANDLER_SELECTION_REQUEST:
      return handleUserHandlerSelectionRequest(action, state);
    case DELETE_USER_HANDLER_SELECTION_REQUEST:
      return handleUserHandlerSelectionDeleteRequest(action, state);
    case LOGGED_OUT:
      return initialState;
    default:
      return state;
  }
};
